import { render } from "./cta.vue?vue&type=template&id=0447196a&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=0447196a&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0447196a"]])

export default __exports__